import React from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";

function Home() {
  document.title="HR Game Home Page"
  return (
    <div>
      <div className="hero_area">
        {/* header section strats */}
        <header className="header_section">
          <div className="container-fluid">
            <nav className="navbar navbar-expand-lg custom_nav-container pt-3">
              <Link className="navbar-brand" to="/">
                <img src="images/logo.png" alt />
                <span>HR Game</span>
              </Link>
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon" />
              </button>
              <div
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav ml-auto mr-2">
                  <li className="nav-item active">
                    <Link className="nav-link" to="/">
                      Home <span className="sr-only">(current)</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/about">
                      About{" "}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/portfolio">
                      Portfolio{" "}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/game">
                      Game
                    </Link>
                  </li>
                  {/* <li className="nav-item">
              <Link className="nav-link" to="/contact.html">Contact us</Link>
            </li> */}
                </ul>
                {/* <div className="user_option">
            <div className="login_btn-container">
              <Link href>
                Login
              </Link>
            </div>
            <form className="form-inline my-2 my-lg-0">
              <button className="btn  my-2 my-sm-0 nav_search-btn" type="submit" />
            </form>
          </div> */}
              </div>
              <div className="call_btn">
                <Link href>Call: +91 9306421528</Link>
              </div>
            </nav>
          </div>
        </header>
        {/* end header section */}
        <section className="slider_section">
          <div className="container-fluid">
            <div
              id="carouselExampleControls"
              className="carousel slide"
              data-ride="carousel"
            >
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <div className="row">
                    <div className="col-md-3 col-lg-2 offset-md-2">
                      <div className="detail-box">
                        <h1>START GAME</h1>
                        <p>
                          "Unlock the power of your knowledge and let your
                          motivation soar in this exhilarating quiz game!"
                        </p>
                        <div>
                          <Link to="/game">Game</Link>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-7 col-lg-8">
                      <div className="img-box">
                        <img src="images/hero.png" alt />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="carousel-item">
                  <div className="row">
                    <div className="col-md-3 col-lg-2 offset-md-2">
                      <div className="detail-box">
                        <h1>IMPROVE YOU SKILL</h1>
                        <p>
                          "Level up your skills and conquer the game !" by HR
                          GAME
                        </p>
                        <div>
                          <Link to="/game">Game</Link>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-7 col-lg-8">
                      <div className="img-box">
                        <img src="images/hero.png" alt />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="carousel-item">
                  <div className="row">
                    <div className="col-md-3 col-lg-2 offset-md-2">
                      <div className="detail-box">
                        <h1>READY</h1>
                        <p>
                          "Fuel your passion, ignite your mind, and conquer the
                          ultimate motivation quiz game!"
                        </p>
                        <div>
                          <Link to="/">GAME</Link>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-7 col-lg-8">
                      <div className="img-box">
                        <img src="images/hero.png" alt />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <a
                className="carousel-control-prev"
                href="#carouselExampleControls"
                role="button"
                data-slide="prev"
              >
                <span className="sr-only">Previous</span>
              </a>
              <Link
                className="carousel-control-next"
                href="#carouselExampleControls"
                role="button"
                data-slide="next"
              >
                <span className="sr-only">Next</span>
              </Link>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default Home;
